import React, { useRef, useState } from "react";
import { DialogContent, IconButton, Popover, Typography } from "@mui/material";
import { Help } from "@mui/icons-material";
import Close from "@mui/icons-material/Close";

function HelpPopover(props) {
  const [open, setOpen] = useState(false);
  const anchor = useRef(null);
  return (
    <>
      <IconButton innerRef={anchor} onClick={() => setOpen(true)}>
        <Help />
      </IconButton>
      <Popover
        anchorEl={anchor.current}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        onClose={() => setOpen(false)}
        open={open}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <DialogContent
          style={{
            display: "flex",
            justifyContent: "space-between",
            paddingRight: 0,
            paddingTop: 0,
            alignItems: "center",
          }}
        >
          <Typography style={{ fontSize: "1.3rem", fontWeight: 800 }} variant={"body1"}>
            {props.title}
          </Typography>
          <IconButton onClick={() => setOpen(false)}>
            <Close />
          </IconButton>
        </DialogContent>
        <DialogContent style={{ maxWidth: 450 }}>
          <Typography>{props.text}</Typography>
        </DialogContent>
      </Popover>
    </>
  );
}

export default HelpPopover;
